"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

var react_1 = require("react");

var usePageLeave = function usePageLeave(onPageLeave, args) {
  if (args === void 0) {
    args = [];
  }

  react_1.useEffect(function () {
    if (!onPageLeave) {
      return;
    }

    var handler = function handler(event) {
      event = event ? event : window.event;
      var from = event.relatedTarget || event.toElement;

      if (!from || from.nodeName === 'HTML') {
        onPageLeave();
      }
    };

    document.addEventListener('mouseout', handler);
    return function () {
      document.removeEventListener('mouseout', handler);
    };
  }, args);
};

exports["default"] = usePageLeave;